import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import React from 'react'

interface Props {
  tileInclusionsList: Array<App.OfferInclusion>;
}

function OfferPageIntroInclusions(props: Props) {
  const {
    tileInclusionsList,
  } = props

  return (
    <div>
      {tileInclusionsList.map(inclusion => (
        <OfferInclusionItem key={inclusion.description} inclusion={inclusion} size="large" showMinStayDescription />
      ))}
    </div>
  )
}

export default OfferPageIntroInclusions
